import { ApolloProvider as ApolloProviderLibs } from '@apollo/client/react';
import React, { memo, useMemo } from 'react';

import { createApolloClient } from './client';

export const ApolloProvider: React.FCWithChildren = memo((props) => {
  // Auth link will automatically handle token management from cookies
  const client = useMemo(() => {
    return createApolloClient();
  }, []);

  return <ApolloProviderLibs client={client}>{props.children}</ApolloProviderLibs>;
});

ApolloProvider.displayName = 'ApolloProvider';
